module.exports = __webpack_public_path__ + "img/7.4ce3e733.svg";